import { useState } from 'react';
import { DragDropContext, Draggable, Droppable } from '@hello-pangea/dnd';
import { Grid } from '@mui/material';
import Scope from '../../redux/containers/project/Scope';

export default function DragabbleCard({
  scopes: initialScopes,
  project,
  created_by,
  users,
  role,
  updateScopes,
  loadingUpdate,
  getScopes,
}) {
  const [scopes, setScopes] = useState([...initialScopes]);

  const handleDragEnd = async result => {
    if (!result.destination || result.destination.index === result.source.index) return;
    const reordered = Array.from(scopes);
    const [moved] = reordered.splice(result.source.index, 1);
    reordered.splice(result.destination.index, 0, moved);
    setScopes(reordered);
    loadingUpdate(true);
    await updateScopes({ scopes: reordered.flatMap((s, i) => [s.id, i]), to_update: 'list' });
    await getScopes(project.id);
    loadingUpdate(false);
  };

  return (
    <DragDropContext onDragEnd={handleDragEnd}>
      <Droppable droppableId="scope-reorder">
        {provided => (
          <Grid
            container
            ref={provided.innerRef}
            {...provided.droppableProps}
            columns={{ xs: 4, sm: 8, md: 12 }}>
            {scopes.map((scope, index) => (
              <Draggable key={scope.id} draggableId={String(scope.id)} index={index}>
                {draggableProvided => (
                  <Grid
                    item
                    xs={4}
                    ref={draggableProvided.innerRef}
                    {...draggableProvided.draggableProps}
                    {...draggableProvided.dragHandleProps}>
                    <Scope
                      scope={scope}
                      project={project}
                      created_by={created_by}
                      users={users}
                      role={role}
                      isDragging={true}
                      noMargin={true}
                    />
                  </Grid>
                )}
              </Draggable>
            ))}
            {provided.placeholder}
          </Grid>
        )}
      </Droppable>
    </DragDropContext>
  );
}
